// Notes on these structured questions are saved as locally entered conditions.
export function hasStructuredSubmission(
  structuredType: string,
  data: unknown,
  note?: string,
): boolean {
  return (
    (Array.isArray(data) && data.length > 0) ||
    ((structuredType === "diagnosis" || structuredType === "symptom") &&
      !!note?.trim())
  );
}
